<template lang="pug">
  div
    el-tabs.content(:value="menu" @tab-click="mudarTab")
      template(v-for="tab in tabs")
        el-tab-pane(:name="tab.name")
          span(slot="label")
            | {{tab.label}} &nbsp
      div.container-tab
        router-view(
          :processo="processo"
          :radiosAcoes="radiosAcoes"
          :radioInicial="radioInicial"
        )

</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import statusProcesso from '@/constants/statusProcessoArrecadacao'
import BaseAnaliseProcessos from '@/screens/arrecadacao/mixins/BaseAnaliseProcessos'

const PROCESSO_EMPTY = {
  numeroProcesso: null,
  cadastroColetivo: {
    dataFinalizacao: null,
    georreferenciamento: {
      geom: null,
      area: 0,
      perimetro: 0,
      municipios: []
    },
    pecaTecnica: {
      memorialDescritivo: null
    },
    usuario: {
      pessoa: {
        nomeRazaoSocial: ''
      }
    },
    perfil: { nome: '' }
  },
  despachos: []
}

export default {
  mixins: [BaseAnaliseProcessos],
  data () {
    return {
      processo: cloneDeep(PROCESSO_EMPTY),
      radios: [],
      radiosAcoes: [],
      despachos: []
    }
  },

  created () {
    this.init()
  },

  computed: {
    indexTabAtual () {
      return this.tabs.findIndex(tab => tab.name === this.$route.name)
    },

    tabs () {
      const acoes = []
      let visualizarProcessoUrl = 'informarEnvio'

      const codigo = this.processo.status
      if (codigo === statusProcesso.AGUARDANDO_ENVIO_DIARIO_OFICIAL) {
        acoes.push({
          label: 'Encaminhar para publicação',
          name: 'informarEnvio/encaminhar',
          dadosRequest: {
            url: '',
            dados: this.processo
          }
        })
      }
      if (
        codigo === statusProcesso.AGUARDANDO_PUBLICACAO_DIARIO_OFICIAL ||
        codigo === statusProcesso.PUBLICACAO_DIARIO_OFICIAL_EM_ANDAMENTO
      ) {
        visualizarProcessoUrl = 'diarioOficial'
        acoes.push({
          label: 'Confirmar publicação no Diário Oficial',
          name: 'diarioOficial/confirmar',
          dadosRequest: {
            url: '',
            dados: this.processo
          }
        })
      }

      acoes.push({
        label: 'Análise do processo ' + this.processo.numeroProcesso,
        name: `${visualizarProcessoUrl}/visualizarProcesso`
      })

      return acoes
    },

    menu () {
      return this.$route.name
    },

    isPrimeiroPasso () {
      return this.indexTabAtual === 0
    },

    isUltimoPasso () {
      return this.indexTabAtual === this.tabs.length - 1
    }
  },

  methods: {
    mudarTab (componente) {
      const indexTab = this.tabs.findIndex(
        tab => tab.name === componente._props.name
      )
      this.navigate(indexTab)
    },

    async navigate (indexTab) {
      const query = {}

      if (this.processo.id) {
        query.idProcesso = this.processo.id
      }

      if (this.processo.portaria.id) {
        query.idPortaria = this.processo.portaria.id
      }

      try {
        this.$router.push({
          name: this.tabs[indexTab].name,
          query
        })
      } catch (error) {
        throw error
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$font-size-small: 12px;

.content {
  flex: 1;
  padding-top: 10px;
}

.container-tab {
  padding: 10px;
}

pre {
  font-size: $font-size-small;
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/gp/DiarioOficial.vue